var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonenumberIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.744,
    height: 19.8,
    viewBox: "0 0 19.744 19.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mage_phone-call",
    d: "M17.346,10.97a4.923,4.923,0,0,0-4.922-4.922m8.3,4.578A7.875,7.875,0,0,0,12.844,2.75m-.577,16.995c-.292-.133-.583-.267-.874-.425a18.1,18.1,0,0,1-3.9-2.962,17.124,17.124,0,0,1-3.642-4.941,10.7,10.7,0,0,1-.971-3.155,5.643,5.643,0,0,1,.352-3.29,6.032,6.032,0,0,1,.983-1.214,1.712,1.712,0,0,1,1.215-.57,1.905,1.905,0,0,1,1.214.7C7.3,4.62,8.008,5.276,8.7,5.968a1.371,1.371,0,0,1,.474.922,1.3,1.3,0,0,1-.328.813c-.231.292-.51.558-.776.837a1.459,1.459,0,0,0-.438,1.214,3.5,3.5,0,0,0,.838,1.385q.69.941,1.445,1.832A12.943,12.943,0,0,0,13.2,15.691a1.216,1.216,0,0,0,1.215.146,3.855,3.855,0,0,0,1.08-.9,1.6,1.6,0,0,1,1.044-.571,1.437,1.437,0,0,1,.959.438c.327.278.606.606.91.91s.547.522.8.8a9.729,9.729,0,0,1,.861.862,1.36,1.36,0,0,1,.279.947,1.994,1.994,0,0,1-.667,1.031,4.544,4.544,0,0,1-3.569,1.385A10.125,10.125,0,0,1,12.268,19.745Z",
    transform: "translate(-1.877 -1.85)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonenumberIcon);
export default __webpack_public_path__ + "static/media/phonenumber-icon.f965511a79f6e48ea27afb3937dc5de1.svg";
export { ForwardRef as ReactComponent };